import React from 'react';
import { bool, func } from 'prop-types';
import Icon from '@material-ui/core/Icon';

// Cookie notice: a small box in the bottom-left corner rather than a full-width bar
const ConsentFooter = ({ isDismissed, openTosDialog, dismiss }) => (
  <div
    style={{
      display: isDismissed ? 'none' : 'flex',
      alignItems: 'center',
      gap: 12,
      position: 'fixed',
      left: 16,
      bottom: 16,
      maxWidth: 'min(420px, calc(100vw - 32px))',
      boxSizing: 'border-box',
      padding: '10px 14px',
      borderRadius: 8,
      backgroundColor: '#263238',
      color: '#ECEFF1',
      fontSize: 13,
      lineHeight: 1.45,
      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.25)',
      zIndex: 1300
    }}
  >
    <div>
      DiffNow uses cookies to run the site and to understand how it&apos;s used. See our{' '}
      <a
        href="#terms-of-service"
        style={{ color: '#FFEE58', textDecoration: 'underline', cursor: 'pointer' }}
        onClick={openTosDialog}
      >
        Terms of Service
      </a>
      .
    </div>
    <Icon
      role="button"
      aria-label="Close"
      style={{ cursor: 'pointer', fontSize: 20, flexShrink: 0 }}
      onClick={dismiss}
    >
      close
    </Icon>
  </div>
);

ConsentFooter.propTypes = {
  isDismissed: bool,
  openTosDialog: func,
  dismiss: func
};

export default ConsentFooter;
